module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_7-f1caa90335287e7cb538a6f4bb5f2096.jpg";